export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <span className="text-2xl font-display text-background-50">99漫画</span>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              免费好看的韩漫日漫国漫大全，完整版全集下拉式阅读，实时追更收藏推荐，漫画在线尽享阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-3">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '最新更新', href: '#updates' },
                { label: '热门话题', href: '#topics' },
                { label: '平台特色', href: '#features' },
                { label: '编辑推荐', href: '#cards' },
                { label: '常见问题', href: '#faq' },
              ].map((link, i) => (
                <a
                  key={i}
                  href={link.href}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-3">漫画分类</h4>
            <div className="flex flex-col gap-2">
              {['恋爱甜宠', '热血战斗', '奇幻冒险', '悬疑惊悚', '搞笑日常'].map((cat, i) => (
                <a
                  key={i}
                  href="#index"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-3">合作伙伴</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              期待与更多优秀的内容创作者和平台建立合作关系。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#contact" className="w-8 h-8 rounded-full bg-background-700 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#contact" className="w-8 h-8 rounded-full bg-background-700 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#contact" className="w-8 h-8 rounded-full bg-background-700 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="Twitter">
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a href="#contact" className="w-8 h-8 rounded-full bg-background-700 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="Email">
                <i className="ri-mail-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 99漫画网. 本站内容仅供学习交流，版权归原作者所有。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">回到顶部</a>
            <a href="#contact" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}